import {Component, Inject, Input} from '@angular/core';
import {Router} from '@angular/router';
import {AlertsCopy, PaymentMethodDetails} from '@ox/typings';
import {TrackingService, WINDOW} from '@ox/utils';
import {PaymentUrlService} from '../../services';
@Component({
  selector: 'webu-ox-grouped-alerts, ox-grouped-alerts',
  templateUrl: './grouped-alerts.component.html'
})
export class GroupedAlertsComponent {
  @Input({required:true}) userRole:string;
  @Input({required:true}) userName:string;
  @Input() paymentMethod?:PaymentMethodDetails;
  @Input() alerts?:AlertsCopy[];
  @Input() currentPageName='generic_page';


  constructor(
    private router:Router,
    @Inject(WINDOW) private window: Window,
    private trackingService:TrackingService,
    private paymentUrlService:PaymentUrlService
  ){}
  handleUrl(buttonText:string,url:string) {
    this.handleProp10Tracking(buttonText);
    if(url.slice(0,2) === '//') //Check for external link
      this.window.location.href = url;
    else this.router.navigate([url]);
  }
  handlePaymentMethod(buttonText:string){
    this.handleProp10Tracking(buttonText);
    this.window.location.href = this.paymentUrlService.buildUrlForPaymentHistoryPage(this.window.location.href);
  }
  handleProp10Tracking(buttonText:string): void {
    const linkText = `${this.currentPageName}:link:${buttonText}`;
    this.trackingService.fireProp10Tracking(linkText,'',this.currentPageName,buttonText);
  }
}
